// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/marketing/crm/v1/crm.proto (package stailer_service_specification.marketing.crm.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");

/**
 * Describes the file stailer_service_specification/marketing/crm/v1/crm.proto.
 */
const file_stailer_service_specification_marketing_crm_v1_crm = /*@__PURE__*/
  fileDesc("CjhzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9tYXJrZXRpbmcvY3JtL3YxL2NybS5wcm90bxIuc3RhaWxlcl9zZXJ2aWNlX3NwZWNpZmljYXRpb24ubWFya2V0aW5nLmNybS52MSIKCghCcmF6ZUNybWIGcHJvdG8z");

/**
 * Describes the message stailer_service_specification.marketing.crm.v1.BrazeCrm.
 * Use `create(BrazeCrmSchema)` to create a new message.
 */
const BrazeCrmSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_marketing_crm_v1_crm, 0);


exports.file_stailer_service_specification_marketing_crm_v1_crm = file_stailer_service_specification_marketing_crm_v1_crm;
exports.BrazeCrmSchema = BrazeCrmSchema;
